import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    questions: null,
  },
  getters: {
    getQuestionsList: state => state.questions,
  },
  mutations: {
    SET_QUESTIONS_LIST(state, list) {
      state.questions = list
    },
  },
  actions: {
    async fetchQuestions({ commit }) {
      try {
        commit('SET_QUESTIONS_LIST', [])
        const res = await axiosIns.get('/drivers/quiz/questions')
        const temp = res.data.data.data.questions
        commit('SET_QUESTIONS_LIST', temp)
        return temp
      } catch (error) {
        console.log(error)
        throw error
      }
    },
    createQuestion(_, questionData) {
      return axiosIns.post('/drivers/quiz/questions/', questionData)
    },
    updateQuestion(_, { questionId, questionData }) {
      return axiosIns.patch(`/drivers/quiz/questions/${questionId}/`, questionData)
    },
    getQuestion(_, questionId) {
      return axiosIns.get(`/drivers/quiz/questions/${questionId}/`)
    },
    deleteQuestion(_, questionId) {
      return new Promise((resolve, reject) => {
        axiosIns.delete(`/drivers/quiz/questions/${questionId}/`)
          .then(() => {
            resolve()
          }).catch(err => reject(err))
      })
    },
  },
}
